import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import fetch from 'features/common/fetch';
import { changeLeadFeedback } from 'features/views/marketPlace/actions';
import {
	feedbackType,
	LEAD_ALREADY_PROCESSED,
	LEAD_RETURNED_TO_MP_DUE_SLA_TIMEOUT,
} from 'features/views/marketPlace/constants';

export const LeadFeedbackConfirm = ({ selectedFeedbackId, leadId, changeSelectedFeedback, type }) => {
	const dispatch = useDispatch();

	const handleCancel = useCallback(() => {
		changeSelectedFeedback(null);
	}, [changeSelectedFeedback]);

	const handleConfirmFeedbackChange = useCallback(() => {
		changeSelectedFeedback(null);
		dispatch(changeLeadFeedback(leadId, selectedFeedbackId, type));
	}, [dispatch, leadId, selectedFeedbackId, changeSelectedFeedback, type]);

	const ignoreErrorsForLeadAlreadyProcessed = useIgnoreErrorsWhen({
		fetchStorePath: fetch.constants.urls.finishLead,
		attributePath: ['metaData', 'parsedContent', 'code'],
		value: LEAD_ALREADY_PROCESSED,
	});

	const ignoreErrorsForLeadReturnedToMpDueSlaTimeout = useIgnoreErrorsWhen({
		fetchStorePath: fetch.constants.urls.finishLead,
		attributePath: ['metaData', 'parsedContent', 'code'],
		value: LEAD_RETURNED_TO_MP_DUE_SLA_TIMEOUT,
	});

	return (
		<Stack
			spacing={3}
			sx={{
				alignItems: 'center',
			}}
		>
			<Typography variant="h4" color="primary.main">
				{getLabelMessage('marketPlace:confirmFeedbackMsg')}
			</Typography>
			<Grid container sx={{ width: '100%' }}>
				<Grid size={12}>
					<Grid
						container
						spacing={3}
						sx={{
							justifyContent: 'center',
						}}
					>
						<Grid size={3}>
							<Button variant="outlined" onClick={handleCancel} fullWidth>
								{getLabelMessage('common:no')}
							</Button>
						</Grid>
						<Grid size={3}>
							<ComponentLoader
								fetchStorePath={fetch.constants.urls.finishLead}
								ignoreErrors={
									ignoreErrorsForLeadReturnedToMpDueSlaTimeout || ignoreErrorsForLeadAlreadyProcessed
								}
							>
								<Button variant="contained" onClick={handleConfirmFeedbackChange} fullWidth>
									{getLabelMessage('common:yes')}
								</Button>
							</ComponentLoader>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	);
};

LeadFeedbackConfirm.propTypes = {
	changeSelectedFeedback: PropTypes.func,
	leadId: PropTypes.number,
	selectedFeedbackId: PropTypes.object,
	type: PropTypes.oneOf([feedbackType.IN_LIST, feedbackType.IN_DETAIL]),
};

export default LeadFeedbackConfirm;
